











































































































































































































































































































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import MemberKey from "@/components/member-key";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }

    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);

    const loading = computed(() => memberStore.loading);
    const response = computed(() => memberStore.response);
    const isShowPin = ref<boolean>(false);
    let displayFlag = ref(false);
    const pinRequestExistsFlag = computed(
      () => memberStore.pinRequestExistsFlag
    );
    const identificationTypeList = computed(
      () => memberStore.identificationTypeList
    );
    const selectedIdentificationType = computed(
      () => memberStore.selectedIdentificationType
    );
    const pinUpdateParams = computed(() => memberStore.pinUpdateParams);
    const s3ImageSrcList = computed(() => memberStore.s3ImageSrcList);

    // 確認実行前からエラーメッセージが出るのを防ぐ用
    const validateUpdateActionFlag = ref<boolean>(false);

    const displayPinUpdateErrorFlag = computed(
      () => memberStore.displayPinUpdateErrorFlag
    );
    const displayPinUpdateError = computed(
      () => memberStore.displayPinUpdateError
    );

    const inputPinUpdatePin = (e: string) => {
      memberStore.inputPinUpdatePin(e);
      memberStore.validatePinUpdateParams();
    };

    const setSelectedIdentificationType = (event: any) => {
      memberStore.setSelectedIdentificationType(event);
      memberStore.validatePinUpdateParams();
    };

    const uploadSelectedImageFileS3 = async (event: any, position: number) => {
      displayuiStore.openOverlayLoading();
      await memberStore.uploadSelectedImageFileS3(event, position);
      memberStore.validatePinUpdateParams();
      displayuiStore.closeOverlayLoading();
      if (response.value.status >= 400) {
        displayuiStore.showErrorSnackBar("画像のアップロードに失敗しました。");
      }
    };

    const submitAction = () => {
      validateUpdateActionFlag.value = true;
      memberStore.validatePinUpdateParams();
      if (!displayPinUpdateErrorFlag.value) {
        context.root.$router.push({ name: "MemberPersonalUpdatePinConfirm" });
      }
    };

    onMounted(async () => {
      memberStore.clearResponse();
      memberStore.clearPinUpdateParams();
      memberStore.clearPinUpdateDisplayError();
      memberStore.setAuthorizationHeader(accessToken.value);
      memberStore.getIdentificationTypeList();
      await memberStore.getPinRequestExists();
      displayFlag.value = true;
    });

    return {
      displayFlag,
      pinUpdateParams,
      s3ImageSrcList,
      identificationTypeList,
      pinRequestExistsFlag,
      selectedIdentificationType,
      inputPinUpdatePin,
      setSelectedIdentificationType,
      uploadSelectedImageFileS3,
      submitAction,
      validateUpdateActionFlag,
      displayPinUpdateErrorFlag,
      displayPinUpdateError,
      loading,
      isShowPin
    };
  },
  components: {}
});
